import type { IconSvgObject } from './types';

const Tap02Icon: IconSvgObject = [
  ["path", { d: "M16.495 22V20L17.1684 18.3358C17.7555 17.0806 18.559 14.6242 17.4362 13.4675C15.7498 11.7302 13.4428 11.4766 12 11.5V6.5C12 5.67157 11.3284 5 10.5 5C9.67157 5 9 5.67157 9 6.5V12M9 12V15M9 12C9 12 6.46171 13 6.06274 14.8673C5.71363 16.5 6.93535 17.8277 6.93535 17.8277L8.97003 20V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.5 6C6.5 3.79086 8.29086 2 10.5 2C12.7091 2 14.5 3.79086 14.5 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tap02Icon;
